export function BenchmarkBar({ benchmark }) {
  if (!benchmark || benchmark.insufficient_peers || typeof benchmark.percentile !== "number") return null;
  const { percentile, peer_count, peer_avg, cuisine_type } = benchmark;
  const position = percentile >= 50 ? "por encima" : "por debajo";
  const positiveClr = percentile >= 50 ? "#059669" : "#dc2626";
  return (
    <div
      className="rounded-lg border border-border/60 bg-card/50 dark:bg-white/5 backdrop-blur-sm px-3 py-2.5"
      data-testid="inv-insight-benchmark"
    >
      <div className="flex items-center justify-between gap-3 mb-1.5">
        <p className="text-[11px] font-semibold uppercase tracking-wide text-muted-foreground">
          Benchmark sectorial
        </p>
        <p className="text-[10px] text-muted-foreground">
          {peer_count} similares · media {peer_avg}/100
        </p>
      </div>
      <div className="relative h-2 w-full rounded-full bg-gradient-to-r from-red-400/30 via-amber-400/30 to-emerald-400/40 overflow-hidden">
        <div
          className="absolute top-1/2 -translate-y-1/2 -translate-x-1/2 w-3 h-3 rounded-full border-2 border-white shadow-md"
          style={{ left: `${Math.max(3, Math.min(97, percentile))}%`, background: positiveClr }}
          data-testid="inv-benchmark-marker"
        />
      </div>
      <p className="text-[11px] mt-1.5 text-foreground/80 leading-snug">
        Estás en el <strong style={{ color: positiveClr }}>percentil {percentile}</strong> — {position} de la media
        {cuisine_type && <span className="text-muted-foreground"> · {cuisine_type}</span>}
      </p>
    </div>
  );
}
